import axiosInstance from "../api/axiosInstance";

const ReceiptPrintService = {

    getPrintInfo: async(companyId: string = "0", reservationId: string = "") => {
        return await axiosInstance().get(`/kiosk/getReceiptContentList.do?companyId=${companyId}&reservationId=${reservationId}`);
    }

}

export default ReceiptPrintService;